import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Modal, Button, Typography, Input } from 'antd'
import { siteContent, infoMsg } from '@services/api'
import infoMsgHelper from '../../../pages/InfoMsg/helper'
const { Paragraph } = Typography

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class EditSiteContentPopup extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            value: ''
        }
        this.handleSave = this.handleSave.bind(this)
        this.closePopup = this.closePopup.bind(this)
    }

    handleSave() {
        const { info } = this.props.popupStore
        const { id, key, handleSetData, isApiContent } = info
        const { value } = this.state

        let callback = isApiContent ? infoMsg.updateContent : siteContent.updateSiteContent

        callback({ id, key: key.key, value })
            .then(res => {
                handleSetData(res.data)
                alert('ערך שונה בהצלחה')
                this.closePopup()
            })
            .catch(err => {
                console.log(err)
                alert('בעיית שרת, ערך לא שונה')
            })
    }

    closePopup() {
        this.props.popupStore.togglePopup(false)
        this.setState({ value: '' })
    }
    componentDidUpdate() {
        const { info, popupType } = this.props.popupStore
        if (popupType == 'editSiteContent' && !this.state.value) this.setState({ value: toJS(info).key.value })
        else if (popupType != 'editSiteContent' && this.state.value) this.setState({ value: '' })
    }
    render() {
        const { info, popupType } = this.props.popupStore
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>סגור</Button>
                <Button type="primary" onClick={this.handleSave}>
                    שמור שינויים
                </Button>
            </div>
        )
        let { key, component, type } = toJS(info)

        return (
            <Modal
                title={`עריכת ${
                    component
                        ? component != 'faq_'
                            ? key.value
                            : 'שאלה ותשובה'
                        : type
                        ? (infoMsgHelper[type].title || type) +
                          ' - ' +
                          ((infoMsgHelper[type].keys &&
                              infoMsgHelper[type].keys[key.key] &&
                              infoMsgHelper[type].keys[key.key].title) ||
                              key.key)
                        : ''
                }`}
                visible={popupType === 'editSiteContent'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
                width={1200}
            >
                {component != 'faq_' ? (
                    <Paragraph editable={{ onChange: value => this.setState({ value }) }}>{this.state.value}</Paragraph>
                ) : (
                    <>
                        <Paragraph
                            editable={{
                                onChange: value => this.setState({ value: { ...this.state.value, q: value } })
                            }}
                        >
                            {this.state.value.q}
                        </Paragraph>
                        <Paragraph
                            editable={{
                                onChange: value => this.setState({ value: { ...this.state.value, a: value } })
                            }}
                        >
                            {this.state.value.a}
                        </Paragraph>
                    </>
                )}
            </Modal>
        )
    }
}
